import { css } from 'styled-components';
import FocusTrap from '../../focus-trap/FocusTrap';

var getArrowDirectionCSS = function getArrowDirectionCSS(props) {
  if (!props.$withArrow) {
    return [];
  }
  /**
   * Used for hiding the arrow when the button has been clicked and
   * is showing the loading spinner.
   */


  var loadingStateStyles = props.isLoading ? "\n  visibility: hidden;\n" : '';

  if (props.$arrowDirection) {
    return css(["", ":after{content:' ", "';pointer-events:none;", "}"], FocusTrap, props.$arrowDirection, loadingStateStyles);
  }

  return css(["", ":after{content:' \\2192';pointer-events:none;", "}[dir='rtl'] && ", ":after{content:' \\2190';pointer-events:none;", "}"], FocusTrap, loadingStateStyles, FocusTrap, loadingStateStyles);
};

export default getArrowDirectionCSS;